import {
	ApplicationDomain,
	DeploymentMode,
	Edition,
	RunMode,
	type ServerSuppliedWebUIConfig,
	SupportMode,
	Type,
	UnlicensedReason,
	type Version,
} from "~/models/dto";

import { DEFAULT_TIME_RANGE_KEY } from "../view/timeline/TimeRange";

export type ConfigState = Omit<ServerSuppliedWebUIConfig, "_type">;

export const initialConfigState: ConfigState = {
	runMode: RunMode.Normal,
	enableAi: false,
	webUIConfig: {
		_type: Type.WebUIConfig,
		featureFlags: {
			_type: Type.WebUIFeatureSwitches,
			eventSummaryUpdateInterval: 0,
			disabledPlugins: [],
			showWelcomePage: false,
			trackingHotJar: false,
			onlineTrial: false,
			visibleStackPacks: undefined,
			trackingPendo: false,
			playground: false,
			trackingGoogleAnalytics: false,
			trackingHubSpot: false,
			newMetrics: false,
			traces: false,
			dashboards: false,
			silencing: false,
		},
		defaultAjaxRequestTimeout: 0,
		metricSelectionLimit: 0,
		streamAddLimit: 0,
		streamReconnectTimeout: 0,
		eventStreamMostRecentCountLimit: 0,
		logStreamMostRecentLimit: 0,
		detailedNodesOnCascadeDeleteLimit: 0,
		streamConnectionStatusChangeDelay: 0,
		searchResultLimit: 0,
		eventsCheckPollingTimeout: 0,
		maxRenderableVisualElements: 0,
		exportModelTimeout: 0,
		importModelTimeout: 0,
		defaultTimeRange: DEFAULT_TIME_RANGE_KEY,
		visualizer: {
			_type: Type.VisualizerSettings,
			reduceCrossingsSweeps: 0,
			foreignWeightMultiplier: 0,
			vertexWidth: 0,
			betweenDummyNodeWidth: 0,
			compactionMaxPlaceBlockDepth: 0,
			compactionMaxLinkedListIterations: 0,
			groupRatioX: 0,
			groupRatioY: 0,
		},
		docLinkUrlPrefix: "",
		supportMode: SupportMode.Documentation,
	},
	stqlConfig: {
		_type: Type.StqlParserConfig,
		maxLevels: 0,
	},
	isGuiAuth: false,
	queryVersion: "0.0.0" as Version,
	serverVersion: "0.0.0" as Version,
	deploymentMode: DeploymentMode.SelfHosted,
	edition: Edition.Prime,
	applicationDomains: [ApplicationDomain.Observability],
	subscription: {
		_type: Type.UnlicensedSubscription,
		reason: UnlicensedReason.Missing,
	},
};
